module.exports = __webpack_public_path__ + "img/statlogo.4ff73dca.svg";